const data = {
  name: "Cincinnati Playhouse in the Park",
  url: "http://cincyplay.com/",
  description:
    "Nestled on a hill and commanding a superb view of downtown Cincinnati, Cincinnati Playhouse in the Park has been offering audiences the finest in professional theatre.",
  tags: [
    "backend",
    "frontend",
    "team",
    "Sitefinity",
    "C#",
    "SQL",
    "Angular",
    "HTML",
    "CSS",
    "JavaScript",
  ],
}

export default data
